const isIE = () => {
  const ua = typeof window !== 'undefined' ? window.navigator.userAgent : ''; //Check the userAgent property of the window.navigator object
  const msie = ua.indexOf('MSIE '); // IE 10 or older
  const trident = ua.indexOf('Trident/'); //IE 11
  return msie > 0 || trident > 0;
};

module.exports = {
  ga: 'UA-107862538-2',
  isIE: isIE(),
};
